export const stylePadding = {
  style: {
    padding: 0,
    textAlign: 'center' as const,
  },
};

export const myTheme = {
  token: {
    fontFamily: "'Nunito Sans', sans-serif",
  },
};

export const personalDataFontFamily = myTheme.token.fontFamily;

export const showSorterTooltip = { title: 'Натисніть, щоб відсортувати' };

export const documentActionsContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
};

export const menuBackdropStyle = {
  backdropFilter: 'none',
  backgroundColor: 'transparent',
};

export const menuPaperStyle = {
  marginTop: '4px',
  backgroundColor: '#ffffff',
  color: '#333333',
  '& .MuiMenuItem-root': {
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
};

export const menuLinkStyle = {
  color: 'inherit',
  textDecoration: 'none',
};

export const getComplexServiceCheckboxColor = (clientType?: string): string | null =>
  clientType === 'INDIVIDUAL' ? '#1890ff' : clientType === 'REPRESENTATIVE' ? '#52c41a' : null;

export const getComplexServiceCheckboxSx = (clientType?: string) => {
  const checkboxColor = getComplexServiceCheckboxColor(clientType);

  if (!checkboxColor) {
    return undefined;
  }

  return {
    '&.Mui-checked': {
      color: checkboxColor,
    },
  };
};

export const personalDataMuiTableContainerSx = {
  overflowX: 'auto',
  backgroundColor: '#ffffff',
  boxShadow: 'none',
  border: '0.5px solid #e2e8f0',
  fontFamily: personalDataFontFamily,
};

export const personalDataMuiTableSx = {
  minWidth: 1000,
  backgroundColor: '#ffffff',
  '& .MuiTableCell-root': {
    borderBottom: '0.5px solid #e2e8f0',
  },
};

export const getPersonalDataMuiHeaderCellSx = (width?: number) => ({
  whiteSpace: 'nowrap',
  width,
  fontWeight: 600,
  verticalAlign: 'middle',
  backgroundColor: '#f6f8fa',
  fontFamily: personalDataFontFamily,
  '&:not(:last-of-type)': {
    borderRight: '0.5px solid #e2e8f0',
  },
});

export const personalDataMuiHeaderContentSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
};

export const getPersonalDataMuiSortableHeaderSx = (hasSorter: boolean) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  cursor: hasSorter ? 'pointer' : 'default',
  userSelect: 'none',
});

export const personalDataMuiEmptyCellSx = {
  py: 4,
  backgroundColor: '#ffffff',
  fontFamily: personalDataFontFamily,
};

export const getPersonalDataMuiBodyCellSx = (width?: number) => ({
  width,
  backgroundColor: '#ffffff',
  fontFamily: personalDataFontFamily,
});

export const personalDataMuiRowSx = {
  backgroundColor: '#ffffff',
};

export const personalDataTabsWrapperSx = {
  position: 'relative',
  mb: 2,
  '&::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    borderBottom: '0.5px solid #e2e8f0',
    pointerEvents: 'none',
    zIndex: 0,
  },
};

export const personalDataTabsSx = {
  position: 'relative',
  zIndex: 1,
  minHeight: 0,
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTabs-flexContainer': {
    gap: 0.5,
  },
};

export const personalDataTabSx = {
  textTransform: 'none',
  minHeight: 40,
  position: 'relative',
  fontFamily: personalDataFontFamily,
  fontWeight: 600,
  color: '#334155',
  backgroundColor: '#f6f8fa',
  borderTop: '0.5px solid #e2e8f0',
  borderLeft: '0.5px solid #e2e8f0',
  borderRight: '0.5px solid #e2e8f0',
  borderTopLeftRadius: 6,
  borderTopRightRadius: 6,
  '&.Mui-selected': {
    color: '#0f172a',
    backgroundColor: '#ffffff',
    zIndex: 2,
    '&::after': {
      content: '""',
      position: 'absolute',
      left: '-0.5px',
      right: '-0.5px',
      bottom: '-0.5px',
      borderBottom: '1px solid #ffffff',
    },
  },
};

export const personalDataHiddenFieldSx = {
  cursor: 'help',
  filter: 'blur(1.5px)',
  userSelect: 'none',
  display: 'inline-block',
};
